import { FC } from 'react';
import { Typography } from '@mui/material';

import { CardContent, CardHeader } from './Card';
import CollapsibleCard, { CollapsibleCardProps } from '../../../../../components/Card/CollapsibleCard/CollapsibleCard';
import CollapsibleCardExpandArea from '../../../../../components/Card/CollapsibleCard/CollapsibleCardExpandArea';
import CollapsibleCardExpandButton from '../../../../../components/Card/CollapsibleCard/CollapsibleCardExpandButton';
import Row from '../../../../../components/Row';

import { Campaign } from '../../../../../types/Campaign';
import CampaignMetaOverviewList from '../List/CampaignMetaOverviewList';

interface CampaignMetaOverviewCardProps {
    campaign: Campaign;
    slotProps?: {
        collapsibleCard?: Partial<CollapsibleCardProps>;
    };
}

const CampaignMetaOverviewCard: FC<CampaignMetaOverviewCardProps> = ({ campaign, slotProps = {} }) => {
    return (
        <CollapsibleCard
            {...slotProps?.collapsibleCard}
            sx={{
                '& .MuiCardContent-root:last-child': {
                    p: 0,
                },
            }}
        >
            <CardHeader
                title={
                    <Row alignItems="center" gap={1}>
                        <Typography variant="body1">Additional Info</Typography>
                    </Row>
                }
                action={<CollapsibleCardExpandButton />}
            />
            <CollapsibleCardExpandArea>
                <CardContent sx={{ p: 0 }}>
                    <CampaignMetaOverviewList campaign={campaign} />
                </CardContent>
            </CollapsibleCardExpandArea>
        </CollapsibleCard>
    );
};

export default CampaignMetaOverviewCard;
